const options = {
  fallbackLng: 'en',
  load: 'currentOnly',
  supportedLngs: ['de', 'en', 'es', 'fr', 'it', 'ja', 'ko', 'pt', 'zh-CN', 'zh-TW']
};

export { options as default };
